import { render } from "./CriarDespedida.vue?vue&type=template&id=6ca6a848&scoped=true"
import script from "./CriarDespedida.vue?vue&type=script&lang=js"
export * from "./CriarDespedida.vue?vue&type=script&lang=js"

import "./CriarDespedida.vue?vue&type=style&index=0&id=6ca6a848&lang=css"
import "./CriarDespedida.vue?vue&type=style&index=1&id=6ca6a848&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca6a848"]])

export default __exports__